/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``lock.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const LockIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M4.5 6C4.5 3.51472 6.51472 1.5 9 1.5C11.4853 1.5 13.5 3.51472 13.5 6V6.86274C13.712 6.90919 13.9154 6.97682 14.112 7.07698C14.6765 7.3646 15.1354 7.82354 15.423 8.38803C15.6085 8.75203 15.6824 9.13956 15.7169 9.56113C15.75 9.96702 15.75 10.4653 15.75 11.069V12.181C15.75 12.7847 15.75 13.283 15.7169 13.6889C15.6824 14.1104 15.6085 14.498 15.423 14.862C15.1354 15.4265 14.6765 15.8854 14.112 16.173C13.748 16.3585 13.3604 16.4324 12.9389 16.4669C12.533 16.5 12.0347 16.5 11.431 16.5H6.56901C5.96529 16.5 5.46702 16.5 5.06113 16.4669C4.63956 16.4324 4.25203 16.3585 3.88803 16.173C3.32354 15.8854 2.8646 15.4265 2.57698 14.862C2.39151 14.498 2.31759 14.1104 2.28315 13.6889C2.24998 13.283 2.24999 12.7847 2.25 12.181V11.069C2.24999 10.4653 2.24998 9.96703 2.28315 9.56113C2.31759 9.13956 2.39151 8.75203 2.57698 8.38803C2.8646 7.82354 3.32354 7.3646 3.88803 7.07698C4.08461 6.97682 4.28804 6.90919 4.5 6.86274V6ZM6 6.75122C6.17828 6.74999 6.3678 6.75 6.56903 6.75H11.431C11.6322 6.75 11.8217 6.74999 12 6.75122V6C12 4.34315 10.6569 3 9 3C7.34315 3 6 4.34315 6 6V6.75122ZM5.18328 8.27816C4.85447 8.30503 4.68631 8.35372 4.56902 8.41349C4.28677 8.5573 4.0573 8.78677 3.91349 9.06901C3.85372 9.18631 3.80503 9.35447 3.77816 9.68328C3.75058 10.0208 3.75 10.4576 3.75 11.1V12.15C3.75 12.7924 3.75058 13.2292 3.77816 13.5667C3.80503 13.8955 3.85372 14.0637 3.91349 14.181C4.0573 14.4632 4.28677 14.6927 4.56902 14.8365C4.68631 14.8963 4.85447 14.945 5.18328 14.9718C5.52085 14.9994 5.95757 15 6.6 15H11.4C12.0424 15 12.4792 14.9994 12.8167 14.9718C13.1455 14.945 13.3137 14.8963 13.431 14.8365C13.7132 14.6927 13.9427 14.4632 14.0865 14.181C14.1463 14.0637 14.195 13.8955 14.2218 13.5667C14.2494 13.2292 14.25 12.7924 14.25 12.15V11.1C14.25 10.4576 14.2494 10.0208 14.2218 9.68328C14.195 9.35447 14.1463 9.18631 14.0865 9.06901C13.9427 8.78677 13.7132 8.5573 13.431 8.41349C13.3137 8.35372 13.1455 8.30503 12.8167 8.27816C12.4792 8.25058 12.0424 8.25 11.4 8.25H6.6C5.95757 8.25 5.52085 8.25058 5.18328 8.27816ZM9 10.125C9.41421 10.125 9.75 10.4608 9.75 10.875V12.375C9.75 12.7892 9.41421 13.125 9 13.125C8.58579 13.125 8.25 12.7892 8.25 12.375V10.875C8.25 10.4608 8.58579 10.125 9 10.125Z"
        transform=""
      />
    </g>
  </svg>
);

LockIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

LockIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

LockIcon.displayName = "LockIcon";

export default LockIcon;
